// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard'; // Ini akan jadi halaman overview
import UserProgressDashboard from './components/management/UserProgressDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext';
import MainLayout from './components/layout/MainLayout'; // <- IMPORT LAYOUT BARU
import MissionManagement from './components/management/MissionManagement'; // <- IMPORT HALAMAN MISI
// Import halaman manajemen lain di sini
// import VoucherManagementPage from './components/management/VoucherManagementPage';
// import EventManagementPage from './components/management/EventManagementPage';
import './App.css';
import AdminManagementPage from './components/management/AdminManagementPage';
import UserReportPage from './components/management/UserReportPage';

function RedirectIfLoggedIn({ children }) {
  const auth = useAuth();
  return auth.isLoggedIn ? <Navigate to="/dashboard" replace /> : children;
}

function AppContent() {
  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            <RedirectIfLoggedIn>
              <Login />
            </RedirectIfLoggedIn>
          }
        />

        {/* Rute yang menggunakan MainLayout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainLayout /> {/* MainLayout dirender di sini */}
            </ProtectedRoute>
          }
        >
          {/* Rute anak akan dirender di dalam <Outlet /> di MainLayout */}
          <Route index element={<UserProgressDashboard />} /> {/* /dashboard */}
          <Route path="missions" element={<MissionManagement />} /> {/* /dashboard/missions */}
          <Route path="admins" element={<AdminManagementPage />} /> {/* <-- TAMBAHKAN RUTE INI */}
          <Route path="reports/users" element={<UserReportPage />} /> {/* <-- TAMBAHKAN RUTE INI */}
          {/* <Route path="vouchers" element={<VoucherManagementPage />} /> 
          <Route path="events" element={<EventManagementPage />} /> 
          */}
          {/* Tambahkan rute anak lain di sini */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} /> {/* Fallback di dalam dashboard */}
        </Route>

        {/* Rute default: Redirect ke dashboard jika login, ke login jika tidak */}
        <Route
          path="/"
          element={<NavigateBasedOnAuth />}
        />

        {/* Rute fallback jika path tidak ditemukan di luar /dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

function NavigateBasedOnAuth() {
  const auth = useAuth();
  return auth.isLoggedIn ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <AppContent />
      </div>
    </AuthProvider>
  );
}

export default App;